import type { IconData } from '@stacksjs/iconify-core'

export const hourglass: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M17.017 24c0-3-10.358-8.376-7.527-15.166C11.412 4.227 16.79 3 23.987 3c7.283 0 12.734 1.035 14.59 5.817C41.172 15.507 30.986 21 30.986 24s10.186 8.493 7.59 15.182C36.722 43.965 31.27 45 23.988 45c-7.197 0-12.575-1.227-14.497-5.834C6.66 32.376 17.017 27 17.017 24\"/><path d=\"M24 39c-2.511 0-4.508-.257-6.035-.587c-2.245-.485-2.8-2.958-1.225-4.63C18.835 31.559 21.737 29 24 29s5.165 2.56 7.26 4.783c1.574 1.672 1.02 4.145-1.225 4.63c-1.528.33-3.524.587-6.035.587m7.734-24.966C30.112 13.523 27.579 13 24 13s-6.112.523-7.734 1.034q.061.084.13.167C18.505 16.788 21.61 20 24 20s5.494-3.212 7.605-5.799q.067-.082.129-.167\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default hourglass
